
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../mcss/main.css";
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import Dialog_IRN from '../Dialog_IRN';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import Tran_data_unlock_request from "../Tran_data_unlock_request";

function Tran_adi() {
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [radioType, setRadioType] = useState("N");

    const [newDate, setNewDate] = useState(new Date());
    const [ppSrnoFrom, setPPSrnoFrom] = useState("");
    const [ppSrnoTo, setPPSrnoTo] = useState("");
    const [ppFromDate, setPPFromDate] = useState(new Date());
    const [ppToDate, setPPToDate] = useState(new Date());

    const [list, setList] = useState([]);

    const [location, setLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [ppStateType, setPPStateType] = useState(0);
    const [stateCode, setPPStateCode] = useState(0);
    const [userRight, setUserRight] = useState([]);

    const [scrMode, setScrMode] = useState("");
    const [hdrSrno, setHdrSrno] = useState(0);
    const [individual, setIndividual] = useState(null);
    const [serviceType, setServiceType] = useState("");
    const [corporate, setCorporate] = useState(null);
    const [nArrivalDate, setNArrivalDate] = useState(null);
    const [isd, setPIsd] = useState(null);
    const [value, setValue] = useState("");
    const [rate, setPRate] = useState("");
    const [settRate, setSettRate] = useState(0);
    const [pProduct, setPProduct] = useState("TT");
    const [randomString, setRandomString] = useState("");
    const [pProductList, setPProductList] = useState([]);
    const [totalAmount, setPTotalAmount] = useState(0);
    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [forexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);
    const [agent, setAgent] = useState(null);
    const [isCommission, setIsCommission] = useState("1");
    const [commType, setCommType] = useState("F");
    const [commValue, setCommValue] = useState(0);
    const [key, setKey] = useState("INFO");
    const [paymentData, setPaymentData] = useState([]);
    const [commission, setCommission] = useState("");
    const [hdrDate, setHdrDate] = useState(null);
    const [hdrLocation, setHdrLocation] = useState("");
    const [viewDate, setViewDate] = useState('');
    const [usdRate, setUSDRate] = useState('');
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [filterProduct, setFilterProduct] = useState("C");

    const [isIrnGenerated, setIsIrnGenerated] = useState("0");
    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
    const [individualName, setIndividualName] = useState("");
    const [individualPan, setIndividualPan] = useState("");
    const [individualAddress, setIndividualAddress] = useState("");

    const [corporateName, setCorporateName] = useState("");
    const [agentName, setAgentName] = useState("");
    const [agentAddress, setAgentAddress] = useState("");
    const [agentPan, setAgentPan] = useState("");
    const [trandate, setTrandate] = useState(null);

    const [individualId, setIndividualId] = useState("");
    const [individualNumber, setIndividualNumber] = useState("");
    const [branchProfitPercent, setBranchProfitPercent] = useState("");
    const [branchProfitInr, setBranchProfitInr] = useState("");
    const [grossMarginafterGst, setGrossMarginAfterGst] = useState("");
    const [grossMarginInr, setGrossMarginInr] = useState("");
    const [bankMarginPercent, setBankMarginPercent] = useState(0.2);
    const [grossMarginPercent, setGrossMarginPercent] = useState("");
    const [purpose, setPurpose] = useState(null);
    const [issuer, setIssuer] = useState(null);
    const [issuerGroup, setIssuerGroup] = useState("");
    const [issuerAccount, setIssuerAccount] = useState("");
    const [editLogObject, setEditLogObject] = useState([]);
    const [showEditRequest, setShowEditRequest] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setLocation(response);
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_ADI'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
    }, []);

    useEffect(() => {
        let forexTotal = value * rate;
        let commVal = commValue;
        setPForexTotal(forexTotal);
        let bankMarginVal = 0;
        if (forexTotal > 0 && bankMarginPercent > 0) {
            bankMarginVal = (bankMarginPercent * forexTotal) / 100;
        }
        let total = forexTotal * 1 + commVal * 1 + bankMarginVal * 1 + pOtherCharges * 1;
        // console.log("Total: ", total, " Forex Total: ", forexTotal, " Comm Val: ", commVal, " Bank Margin Val: ", bankMarginVal, " Other Charges: ", pOtherCharges);
        setPTotalAmount(total);
        //create product list 
        if (forexTotal > 0 && scrMode !== 'Q') {
            const product = [
                { prd_amount: forexTotal }
            ]
            const obj = {
                tranType: "ADI",
                type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                nState: serviceType === "R" ? stateCode : corporate?.id?.split('^')[3],//retail h to branch value jayegi corporate me corporate value jayegi
                pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges * 1,
                ppStateType: ppStateType,//branch location se aayega (S or U)
                ppStateValue: stateCode,//branch location se aayega(location code)
                corporate: corporate
            }
            calcInvoice(product, obj);
        }
    }, [value, rate, commValue, bankMarginPercent, pOtherCharges]);

    const handleTabChange = (k) => {
        setKey(k);
    }

    const addNewForm = () => {
        var d = Common.dateYMD(newDate);
        var ddmy = Common.dateDMY(newDate);
        var ymd = Common.dateYMD(newDate);
        var today = Common.dateYMD(new Date());

        if (location == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                addNewFormResetFields(ddmy, ymd);
            } else {
                const obj = {
                    billdate: d,
                    location: locationCode,
                    type: 'ADI'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        addNewFormResetFields(ddmy, ymd);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = (ddmy, ymd) => {
        setSettRate(0)
        setHdrDate(ddmy);
        setScrMode('A');
        setKey('INFO');
        setHdrSrno(0);
        setRandomString(Common.getRandomString(20));
        setIndividual(null);
        setCorporate(null);
        setPForexTotal(0);
        setPTotalAmount(0);
        setPCgst(0);
        setPIgst(0);
        setPUgst(0);
        setPSgst(0);
        setPRoundOff(0);
        setPOtherCharges(0);
        setPIsd(null);
        setValue("");
        setValue("");
        setPRate("");
        setCommValue("");
        setCommission("");
        setAgent(null);
        setCommType("F");
        setServiceType("R");
        setPTaxableVal("");
        setIndividualName("");
        setIndividualPan("");
        setIndividualAddress("");

        setCorporateName("");
        setPurpose();
        setIssuer();
        setGrossMarginAfterGst('')
        setGrossMarginInr('');
        setGrossMarginPercent('');
        setBankMarginPercent(0.2)
    }


    const handleLocationChange = (value) => {
        setLocation(value);
        var id = value.id;
        var location = id.split("^");
        setLocationCode(location[1]);
        setPPStateCode(location[3] == null ? 0 : location[3]);
        setPPStateType(location[4]);
        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        console.log(location[10]);
        sessionStorage.activeBranch = location[1];
    }

    const handleNewIndiviualChange = (value) => {
        console.log("New Individual Picklist: ", value);
        setIndividual(value);
        var id = value.id.split("^");
        setIndividualName(id[3]);
        setIndividualPan(id[4]);
        setIndividualAddress(id[9])
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        const sessionData = JSON.parse(sessionStorage.getItem('values'));
        if (sessionData && sessionData.md_type === "PURCHASE") {
            navigate('/individual-profile');
            sessionStorage.removeItem('values');
            sessionStorage.setItem('flag', '1');
        } else {
            setScrMode('');
        }
    }

    const saveData = () => {
        // $(".loader").show();
        var msg = [], i = 0;
        (Common.dateYMD(newDate) < finStartDate || Common.dateYMD(newDate) > finEndDate && (msg[i++] = "Date should be within financial year"));
        serviceType === "R" && (!individual && (msg[i++] = "Individual,"));
        serviceType === 'C' && (!corporate && (msg[i++] = "Corporate,"));
        !purpose && (msg[i++] = "Purpose,");
        !isd && (msg[i++] = "ISD,");
        !value && (msg[i++] = "Value,");
        !rate && (msg[i++] = "Rate,");
        !settRate && (msg[i++] = "Settlement Rate,");
        !agent && (msg[i++] = "Agent,");
        !commission && (msg[i++] = "Commission,");
        totalAmount <= forexTotal && (msg[i++] = "Total Amount should be greater than Forex Total,");
        if (i > 0) {
            // $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let indiCode = 0;
            let indiIdCode = 0;
            if (serviceType === "R") {
                let individualId = individual.id.split("^");
                indiCode = individualId[1];//individual id
                indiIdCode = individualId[2]; // individual id code
            }
            let purposeCode = 0;
            if (purpose) {
                purposeCode = purpose?.id.split('^')[1];
            }
            let agentCode = agent?.id?.split('^')[1];
            const obj = {
                srno: hdrSrno,
                locationCode: locationCode,
                corporate: corporate,
                individual: individual,
                indiCode: indiCode,
                indiIdCode: indiIdCode,
                serviceType: serviceType,
                newDate: hdrSrno < 1 ? Common.dateYMD(newDate) : hdrDateYmd,
                forexTotal: forexTotal,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
                totalAmount: totalAmount,
                stateCode: stateCode,
                usdRate: usdRate == "" ? 0 : usdRate,
                individualId: individualId,
                individualNumber: individualNumber,
                corporateName: corporateName,
                settRate: settRate,
                purpose: purposeCode,
                issuerGroup: issuerGroup,
                issuerAccount: issuerAccount,
                isd: isd ? isd.id.split("^")[1] : "",
                value: value,
                rate: rate,
                settRate: settRate,
                bankMargin: bankMarginPercent,
                totalAmount: totalAmount,
                adi_value: value,
                adi_rate: rate,
                adi_sett_rate: settRate,
                adi_total: totalAmount,
                adi_gross_margin_pct: grossMarginPercent,
                adi_gross_margin_inr: grossMarginInr,
                adi_gross_margin_inr_after_gst: grossMarginafterGst,
                adi_agent_code: agentCode,
                adi_agent_comm_amt: commValue,
                adi_agent_comm_pct: commType === 'P' ? commission : 0,
                adi_branch_profit_inr: branchProfitInr,
                adi_branch_profit_pct: branchProfitPercent,
                agent: agent,
                isCommission: isCommission,
                commType: commType,
                commission: commission,
                commValue: commValue,
                tranType: "ADI",
                type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                nState: serviceType === "R" ? stateCode : corporate?.id.split('^')[3],//retail h to branch value jayegi corporate me corporate value jayegi
                pOtherCharges: pOtherCharges == "" ? 0 : pOtherCharges * 1,
                ppStateType: ppStateType,//branch location se aayega (S or U)
                ppStateValue: stateCode,//branch location se aayega(location code)
            }
            Common.callApi(Common.apiTranAdi, [sid, "savedata", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                // $(".loader").hide();
                if (resp.status) {
                    setScrMode("");
                    setList(resp.list);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }

    const handleChangeIsd = (value) => {
        setPIsd(value);
    }
    const handlePurposeAdi = (value) => {
        setPurpose(value);
    }
    const handleIssuerChange = (value) => {
        setIssuer(value);
        let a = value.id.split("^");
        setIssuerGroup(a[1]);
        setIssuerAccount(a[2]);
    };


    const calcInvoice = (productlist = [], obj) => {
        Common.callApi(Common.apiCalcTaxable, [sid, "calcinvoice", JSON.stringify(productlist), JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPForexTotal(resp.fxamt);
            setPSgst(resp.sgst);
            setPTotalAmount(resp.totalamt);
            setPTaxableVal(resp.taxablevalue);
            setPRoundOff(resp.roundoff);
            setPCgst(resp.cgst);
            setPIgst(resp.igst);
            setPUgst(resp.ugst);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
        });
    }


    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'ADI',
            pageright: 'TRAN_PP',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'ADI', trannumber: hdrSrno, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    const handleDenoChange = (v) => {
        Common.validateDecValue(v, setValue);
    }

    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        if (isd != null) {
            var isdarr = isd.id.split("^");
            if (isdarr[1] === "USD") {
                setUSDRate(v);
            }
        }
        handleGrossMarginRate(v, settRate);
    }
    const handleSettleRate = (v) => {
        if (v > 0) {
            setSettRate(v);
            handleGrossMarginRate(rate, v);
        }
    }

    const handleAgentChange = (value) => {
        setAgent(value);
        let idArr = value.id.split('^');
        setAgentName(idArr[5]);
        setAgentPan(idArr[12])
        setAgentAddress(idArr[15]);
    }

    const handleCommissionCalc = (v) => {
        Common.validateDecValue(v, setCommission);
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "ADI", trannumber: hdrSrno, trancategory: "T", location: locationCode });
    }

    const handleServiceType = (v) => {
        setServiceType(v);
        setIndividual(null);
        setCorporate(null);
    }
    const resetCorporate = () => {
        setCorporate(null);
    }
    const handleCorporateChange = (value) => {
        setCorporate(value);
    }
    const handleGrossMarginRate = (rate, settRate) => {//setGrossMarginPercent
        console.log(" P Rate: ", rate, " Settle Rate: ", settRate, " Bank Margin: ", bankMarginPercent);
        if (rate * 1 > 0 && settRate * 1 > 0 && rate * 1 > settRate * 1) {
            let grossMarginPerUnit = (rate * 1 - settRate * 1 - bankMarginPercent * 1).toFixed(2);
            setGrossMarginPercent(grossMarginPerUnit)
            if (forexTotal * 1 > 0 && grossMarginPerUnit * 1 > 0) {
                let gMrginInr = (grossMarginPerUnit * value * 1).toFixed(2);
                setGrossMarginInr(gMrginInr);
                let GMarginAfterGst = (gMrginInr / 1.18).toFixed(2);
                setGrossMarginAfterGst(GMarginAfterGst);
                let bProfitInr = gMrginInr - commission * 1;
                setBranchProfitInr(bProfitInr.toFixed(2));
                let bProfitPercent = (bProfitInr / GMarginAfterGst).toFixed(4);
                setBranchProfitPercent(bProfitPercent);
            }
        }

    }
    const listPPdata = () => {
        var msg = [], i = 0;
        // $(".loader").show();
        msg[i++] = Common.getMessage("MSG0006");
        !location && (msg[i++] = " Location.");
        (radioType === 'S' && !ppSrnoFrom) && (msg[i++] = "From Srno.");
        (radioType === 'S' && !ppSrnoTo) && (msg[i++] = " To Srno.");
        (radioType === 'D' && !ppFromDate) && (msg[i++] = "From Date.");
        (radioType === 'D' && !ppToDate) && (msg[i++] = " To Date.");
        if (msg.length > 1) {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                radioType: radioType,
                locationCode: locationCode,
                fromSrno: ppSrnoFrom,
                toSrno: ppSrnoTo,
                filFromDate: Common.dateYMD(ppFromDate),
                filToDate: Common.dateYMD(ppToDate),
            }
            Common.callApi(Common.apiTranAdi, [sid, "list", JSON.stringify(obj)], result => {
                // $(".loader").hide();
                let res = JSON.parse(result);
                if (res.status) {
                    setList(res.list);
                } else {
                    setMsgText(res.msg);
                    setMsgBox(true);
                }
            });
        }
    }
    const viewHandler = (srno) => {
        $(".loader").show();
        setShowEditRequest(false);
        setScrMode("Q");
        const obj = {
            srno: srno,
            locationCode: locationCode
        }
        Common.callApi(Common.apiTranAdi, [sid, "view", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            if (Array.isArray(res) && res.length > 0) {
                updateviewField(res[0])
            } else {
                setMsgText("Data not found.");
                setMsgBox(true);
            }
        });
    }
    function updateviewField(obj) {
        setScrMode('Q');
        setHdrSrno(obj.adi_srno);
        setServiceType(obj.hdr_service_type);
        setHdrLocation(obj.branch_name ?? obj.adi_location);
        setHdrDate(Common.dateDMYStr(obj.adi_date ?? obj.hdr_date));
        setHdrDateYmd(Common.dateYMD(obj.adi_date ?? obj.hdr_date));
        setViewDate(Common.dateDMYStr(obj.adi_date ?? obj.hdr_date));

        setPForexTotal(obj.hdr_forex_total ?? obj.adi_value ?? 0);
        setPTotalAmount(obj.hdr_total_inr ?? obj.adi_total ?? 0);
        setPOtherCharges(obj.hdr_other_charges ?? 0);
        setPTaxableVal(obj.hdr_taxable_value ?? 0);
        setPSgst(obj.hdr_sgst ?? 0);
        setPCgst(obj.hdr_cgst ?? 0);
        setPIgst(obj.hdr_igst ?? 0);
        setPUgst(obj.hdr_ugst ?? 0);
        setPRoundOff(obj.hdr_round_off ?? 0);

        setValue(obj.adi_value ?? 0);
        setPRate(obj.adi_rate ?? 0);
        setSettRate(obj.adi_sett_rate ?? 0);
        setBankMarginPercent(obj.adi_bank_margin ?? 0);
        setGrossMarginPercent(obj.adi_gross_margin_pct ?? 0);
        setGrossMarginInr(obj.adi_gross_margin_inr ?? 0);
        setGrossMarginAfterGst(obj.adi_gross_margin_inr_after_gst ?? 0);
        setBranchProfitInr(obj.adi_branch_profit_inr ?? 0);
        setBranchProfitPercent(obj.adi_branch_profit_pct ?? 0);
        setIndividualName(obj.individual_name ?? '');
        setIndividualId(obj.hdr_individual_id ?? '');
        Common.getIndividualProfilebyProfileIdAndIdCode('ADI', [obj.hdr_individual, obj.hdr_individual_id], handleNewIndiviualChange);
        if (obj.hdr_purpose) {
            setPurpose({
                id: '^' + obj.hdr_purpose + '^' + obj.purpose_name,
                label: ' ' + obj.hdr_purpose + ' ' + obj.purpose_name
            });
        } else {
            setPurpose(null);
        }

        if (obj.hdr_service_type === 'C') {
            Common.getCorporateProfilebyGroupAndAccount('ADI', [obj.hdr_group, obj.hdr_ledger], setCorporate);
        } else {
            setCorporate(null);
        }
        Common.getCorporateProfilebyGroupAndAccount('ADI', [obj.adi_issuer_group, obj.ad_issuer_account], setIssuer);
        setPIsd({ id: '^' + obj.adi_isd + '^' + obj.adi_isd, label: ' ' + obj.adi_isd + ' ' + obj.adi_isd });
        Common.getCorporateProfilebyGroupAndAccount('ADI', [obj.adi_agent_group, obj.ad_issuer_account], setAgent);
        setCommission(obj.adi_agent_comm_pct);
        setBankMarginPercent(obj.adi_bank_margin_p);
        setCommValue(obj.adi_agent_comm_amt);
        setCommType(obj.adi_agent_comm_type);
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Transaction ADI</h2>
                    </Col>
                </Row>
                {
                    scrMode === "" &&
                    <>
                        <Row className='mt-10'>
                            <Col className='col-md-6 col-12'>
                                <Form.Group>
                                    <Row>
                                        <Col>
                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                        </Col>
                                        <Col>
                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                        </Col>
                                        <Col>
                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={location}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleLocationChange}
                                        isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {
                                radioType === "N" ?
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={newDate}
                                                onChange={(date) => setNewDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    : radioType === "S" ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control type='text' maxLength={10} value={ppSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoFrom)} />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control type='text' maxLength={10} value={ppSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoTo)} />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        : radioType === "D" ?
                                            <>

                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={ppFromDate}
                                                            onChange={(date) => setPPFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={ppToDate}
                                                            onChange={(date) => setPPToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </> : null
                            }
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {
                                    +userRight.query === 1 && (radioType !== "N" && radioType !== "R") ?
                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listPPdata()}>List</Button> : null
                                }
                                &nbsp;
                                {
                                    +userRight.add === 1 && radioType === "N" ?
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        {
                            list && list.length > 0 &&
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>SrNo</th>
                                                <th>Date</th>
                                                <th>Individual</th>
                                                <th>Ledger</th>
                                                <th>Total INR</th>
                                                <th>ISD</th>
                                                {/* <th>Action</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="textCenter">
                                                        <span className="handCursor colorThemeBlue" onClick={() => viewHandler(item.hdr_srno)}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.hdr_srno}</td>
                                                    <td>{Common.dateDMYStr(item.hdr_date)}</td>
                                                    <td>{item.hdr_individual + ' ' + item.individual_name}</td>
                                                    <td>{item.hdr_group && (item.hdr_group + ' ' + item.hdr_ledger + ' ' + item.mvli_ledger_name)}</td>
                                                    <td>{item.hdr_total_inr}</td>
                                                    <td>{item.adi_isd}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        }
                    </>
                }
                {scrMode != "" &&
                    <>
                        <Row style={{ display: "none" }}>
                            <Col>
                                <p>{randomString}</p>
                            </Col>
                        </Row>

                        <Row style={{ display: "none" }}>
                            <Col>
                                <p>{randomString}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                &nbsp;
                                {
                                    (+userRight.edit === 1 && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnEditRequest()}>Edit</Button>&nbsp;
                                    </> : null
                                }
                                {
                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                    </> : null
                                }
                                {
                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                        {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                        </> : null
                                        }
                                    </> : null
                                }
                                {
                                    (scrMode === "Q" && +userRight.add === 1) &&
                                    < Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                            </Col>
                            <Col className="col-md-2 col-4">
                                <span>Location : <b>{hdrLocation} </b></span>
                            </Col>
                            <Col className="col-md-2 col-4">
                                <span>Date : <b>{hdrDate}</b></span>
                            </Col>
                            <Col className='ppCharges'>
                                <span><b>Forex Total (INR): {forexTotal}</b></span>
                                &nbsp;
                                <span><b>Total Amount (INR): {totalAmount}</b></span>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                            <Tab eventKey="INFO" title="Info">
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Service Type</Form.Label>
                                            <Form.Select disabled={scrMode === "Q"} value={serviceType} onChange={e => handleServiceType(e.target.value)}>
                                                <option value="R">Retail</option>
                                                <option value="C">Corporate</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {serviceType === 'R' ?
                                    <Row>
                                        <Col className="col-md-12">
                                            <Form.Label>Individual</Form.Label>
                                            <Form.Group>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={individual}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchIndividualPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleNewIndiviualChange}
                                                    isDisabled={scrMode === "Q"}
                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                    components={{ Menu: Picklist.menu }}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    :
                                    <>
                                        <Col className="col-md-12 col-12">
                                            <Form.Group>
                                                <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                    <span>Corporate</span>
                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => resetCorporate()}><Badge bg="secondary">Reset</Badge></span>
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={corporate}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByTypeNoValidityCheck(search, 'CORPORATE', locationCode)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleCorporateChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </>
                                }
                                <Row>
                                </Row>
                                <Row>
                                    <Col className='col-md-3 col-3'>
                                        <Form.Label>Name : <b>{individualName}</b></Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-3">
                                        <span>Pan : <b>{individualPan} </b></span>
                                    </Col>
                                    <Col className="col-md-7 col-6">
                                        <span>Address : <b>{individualAddress}</b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Purpose<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={purpose}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchPurposeAdi(search)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handlePurposeAdi}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h4>Product Info</h4>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={issuer}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, locationCode)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleIssuerChange}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                    < Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={isd}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, pProduct)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleChangeIsd}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label> Value <span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' value={value} maxLength={5} disabled={scrMode === 'Q'}
                                                onChange={e => handleDenoChange(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' placeholder='Rate' value={rate} maxLength={Common.rateMaxLength}
                                                disabled={scrMode === 'Q'} onChange={e => handleRateChange(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Group>
                                            <Form.Label>OtherCharges: &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                maxLength={10}
                                                value={pOtherCharges}
                                                onChange={e => Common.validateNumValue(e.target.value, setPOtherCharges)}
                                                disabled={scrMode === "Q"}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Settlement Rate<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' placeholder='Rate' value={settRate} maxLength={Common.rateMaxLength}
                                                disabled={scrMode === 'Q'}
                                                onChange={e => handleSettleRate(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                &nbsp;

                                <Row>
                                    <Col>
                                        <h4>Agent Info</h4>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='col-md-12 col-12'>
                                        <Form.Group>
                                            <Form.Label>Agent<span className="colorThemeRed">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={agent}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', locationCode)} // location = 1 , 2
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleAgentChange}
                                                isDisabled={scrMode === "Q"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                    <Row>
                                        <Col className='col-md-4 col-6'>
                                            <span>Agent Name : <b>{agentName}</b></span>
                                        </Col>
                                        <Col className="col-md-2 col-2">
                                            <span>Pan : <b>{agentPan} </b></span>
                                        </Col>
                                        <Col>
                                            <span>Address : <b>{agentAddress}</b></span>
                                        </Col>
                                    </Row>
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Select value={commType} disabled={true}>
                                                <option value="">Select</option>
                                                <option value="F">Fix</option>
                                                <option value="P">Percentage</option>

                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Commission<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={5} disabled={scrMode === 'Q'} value={commission} onChange={e => handleCommissionCalc(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Commission Value</Form.Label>
                                            <Form.Control disabled value={commValue} onChange={e => Common.validateDecValue(e.target.value, setCommValue)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>&nbsp;</Row>
                                <Row></Row>

                            </Tab>

                            <Tab eventKey="PAYMENT" title="Payment">
                                <Row>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>SGST: {pSgst}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>IGST: {pIgst}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>CGST : {pCgst}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>UGST : {pUgst}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>
                                <hr />
                                <Row>
                                    <Col><h3>Payment Info</h3></Col>
                                </Row>
                                <Row>
                                    <Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Bank Margin: &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Bank Margin' type='text'
                                                maxLength={10}
                                                value={bankMarginPercent}
                                                onChange={e => setBankMarginPercent(e.target.value)}
                                                disabled={scrMode === "Q"}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Gross Margin(%): &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Gross Margin' type='text'
                                                maxLength={10}
                                                value={grossMarginPercent}
                                                // onChange={e => setGrossMarginPercent(e.target.value)}
                                                disabled={true}
                                            />
                                        </Form.Group>
                                    </Col><Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Gross Margin(INR): &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Gross Margin(INR)' type='text'
                                                maxLength={10}
                                                value={grossMarginInr}
                                                disabled={true}
                                            />
                                        </Form.Group>
                                    </Col><Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Gross Margin(INR) after GST: &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Gross Margin' type='text'
                                                maxLength={10}
                                                value={grossMarginafterGst}
                                                onChange={e => setGrossMarginAfterGst(e.target.value)}
                                                disabled={true}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Branch Profit (%): &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Branch Profit (%)' type='text'
                                                maxLength={10}
                                                value={branchProfitPercent}
                                                onChange={e => setBranchProfitPercent(e.target.value)}
                                                disabled={true}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-md-3 col-6" >
                                        <Form.Group>
                                            <Form.Label>Branch Profit (INR): &nbsp;
                                            </Form.Label>
                                            <Form.Control size='sm' placeholder='Branch Profit (INR)' type='text'
                                                maxLength={10}
                                                value={branchProfitInr}
                                                onChange={e => setBranchProfitInr(e.target.value)}
                                                disabled={true}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>


                            </Tab>
                        </Tabs>
                        <hr />
                        <Row>
                            <Col>
                                <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                &nbsp;
                                {
                                    (+userRight.edit === 1 && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnEditRequest()}>Edit</Button>&nbsp;
                                    </> : null
                                }
                                {
                                    (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                    </> : null
                                }
                                {
                                    (+userRight.query === 1 && scrMode === "Q") ? <>
                                        {(+userRight.edit === 1 && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                        </> : null
                                        }
                                    </> : null
                                }
                                {
                                    (scrMode === "Q" && +userRight.add === 1) &&
                                    < Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                }
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </>
                }

            </Container >
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_adi;